import { BaseDocument } from "./base";
import { UserId } from "./helpers";
import { Money } from "./money";

export enum EInvitationStatus {
    PENDING,
    ACCEPTED,
    REJECTED,
    WITHDRAWN,
    CANCELLED,
    EXPIRED,
    TASK_COMPLETED,
}

export interface Invitation extends BaseDocument {
    freelancerId: string,
    projectId: string,
    taskId: string,
    payout: number,
    inviterId: UserId,
    status: EInvitationStatus,
    description: string | null,
    expiresAt: Date | null,
    responseDate: Date | null,
    ndaRequired: boolean,
    seenByFreelancer: Date | null,
}

export interface IInvitation extends Partial<Invitation> { }